<template>
  <div class="center">
    <dv-border-box-10>
      <div class="center-inner">
        <div class="title">今日直播</div>
        <div class="center-content">
          <swiper :options="swiperOption">
            <swiper-slide v-for="item in resList" :key="item.name">
              <live v-if="item.name" :title="item.name"
                :cover="item.cover + '?imageMogr2/thumbnail/288x162'"
                :status="item.status"
                :runTimeHours="item.runTimeHours"
                :runTimeMins="item.runTimeMins"
                :studentCount="item.studentCount"
                :viewCount="item.viewCount"
                />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </dv-border-box-10>
  </div>
</template>

<script>
import live from './live'
import { getLiveApi } from '@/api/school'
export default {
  name: 'Center',
  components: {
    live
  },
  data () {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        direction: 'vertical',
        slidesPerView: 2,
        observer: true,
        observeParents: true
      },
      resList: []
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getLiveApi({ schoolId: this.schoolId }).then(res => {
        this.resList = res.result
        setTimeout(this.getData, 60000)
      })
    }
  }
}
</script>

<style lang="less">
.center {
    width: 32%;
    margin: 0.5%;
    background-color: rgba(6, 30, 93, 0.5);
    border-radius: 20px;

    .center-inner {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .title {
            padding: 12px 0 8px;
            height: 30px;
            line-height: 30px;
            font-size: 20px;
            width: 100%;
            text-align: center;
            flex-shrink: 0;
        }

        .center-content {
            flex: 1;
            width: 100%;
            overflow: hidden;
            min-height: 0;

            .swiper-container {
                width: 100%;
                height: 100%;
                overflow: hidden !important;
            }

            .swiper-wrapper {
                height: 100% !important;
            }

            .swiper-slide {
                overflow: hidden;
            }
        }
    }
}
</style>
